import { Fragment, useState } from "react";
import { Button, Typography } from "@mui/material";

import "../../details components/nodes.css";
import ActionDrawer from "../add action components/ActionDrawer";

export default function YesSelection({ formikProps, actions, setNewAction }) {
  const [openDrawer, setOpenDrawer] = useState({ state: false, data: {} });

  return (
    <Fragment>
      {formikProps.values.stage >= 3 && (
        <div style={{ width: "100%", marginBottom: "10px" }}>
          <Fragment>
            <Typography variant="h5">Instant Yes Action</Typography>

            {!!formikProps.values.actions && (
              <Typography variant="h5" fontSize={"15px"}>
                Action - {handleShowAction("actions")}
              </Typography>
            )}

            <div style={{ width: "100%" }}>
              <Button
                onClick={() =>
                  setOpenDrawer({ state: true, data: {}, action: "yes" })
                }
                variant="contained"
                style={{ float: "right" }}
              >
                Add Action
              </Button>
            </div>
          </Fragment>
        </div>
      )}

      <ActionDrawer
        setNewAction={setNewAction}
        actions={actions}
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
        formikProps={formikProps}
      />
    </Fragment>
  );

  function handleShowAction(act) {
    let acts = actions.filter(
      (action) => action._id === formikProps.values[act]
    );

    return acts[0] ? acts[0].action_name : "None";
  }
}
